import { Decision } from './enums';

/**
 * Types related to promotion packet assessments
 */

export enum AssessmentType {
  BLINDED = 'BLINDED',
  UNBLINDED = 'UNBLINDED',
  BAR_RAISER = 'BAR_RAISER',
}

export enum AssessmentStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

// Domain model for an assessment record
export interface Assessment {
  id: string;
  packetId: string;
  assessorId: string;
  type: AssessmentType;
  status: AssessmentStatus;
  decision?: Decision;
  justification?: string;
  createdAt: Date;
  updatedAt: Date;
}

/**
 * DTO for creating a new assessment
 */
export interface CreateAssessmentDTO {
  packetId: string;
  type: AssessmentType;
  decision?: Decision;
  justification?: string;
  /** Optional override: managers may supply a user ID to create on behalf of that assessor */
  assessorId?: string;
}

/**
 * DTO for updating an existing assessment
 */
export interface UpdateAssessmentDTO {
  status: AssessmentStatus;
  decision?: Decision;
  justification?: string;
}

export const ASSESSMENT_VALIDATION = {
  MAX_JUSTIFICATION_LENGTH: 5000,
} as const;
